import React, { useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
//import { PDFReader } from 'react-read-pdf';
import { isMobile } from "react-device-detect";
//import { MathJaxContext } from "better-react-mathjax";
import "../tinymce/build/mathquill.css";
import "../styles/bizofficer-a.css";
import { API_URL } from "../utils/EnvVars";
import axios from "axios";
import { checkForTable, checkForTableBlog } from "../utils";
import TableContents from "./TableContents/TableContents";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const config = {
  /* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
  loader: { load: ["input/mml", "output/chtml"] },
  mml: {},
};

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  var etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  const [showProgress, setShowProgress] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataObj, setDataObj] = React.useState({});
  const modalContentContainerRef = useRef(null);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    setDataObj({});
    setShowProgress(false);
    if (props.contentObj) {
      if (
        (!props.contentObj.contentUrl ||
          props.contentObj.contentUrl.length < 15) &&
        props.contentObj.contentType === "Text"
      ) {
        getApiData(props.contentObj);
      } else {
        setDataObj(props.contentObj);
      }
    }
  }, [props.contentObj]);

  async function getApiData(obj) {
    setShowProgress(true);
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };

    axios
      .get(API_URL + "/smartlearning-details?id=" + obj.id, axiosHeader)
      .then((response) => {
        setShowProgress(false);
        if (response.data && response.data.responseTxt === "success") {
          //document.write(JSON.stringify(response.data.obj));
          setDataObj(response.data.obj);
        } else if (
          response &&
          response.data &&
          response.data.responseTxt === "invalidToken"
        ) {
          window.localStorage.clear();
          window.location.href = "logout";
        }
      });
  }

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            style={
              dataObj?.contentType === "Text"
                ? { marginTop: "8px", marginRight: "8px" }
                : { marginTop: "32px", marginRight: "8px" }
            }
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  // {props.contentObj.contentType===4?props.contentObj.contentTitle:null}
  return dataObj ? (
    <>
      <Dialog
        fullScreen
        style={{ margin: 5 }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        {showProgress ? <LinearProgress /> : null}
        {/* Text Modal */}
        {dataObj.contentType === "Text" &&
        (!dataObj.contentUrl || dataObj.contentUrl.length < 10) &&
        dataObj.description &&
        dataObj.description.length > 0 ? (
          <div className="columns-3" ref={modalContentContainerRef}>
            {/* Table of contents */}
            <div md="2">
              <TableContents
                contents={dataObj?.links}
                modalContentContainer={modalContentContainerRef}
              />
            </div>
            {/* Main Content */}
            <div md="8">
              <h1 className="study_material_modal_title">
                {dataObj?.contentTitle}
              </h1>
              <div
                className="study_material_modal"
                dangerouslySetInnerHTML={{
                  __html:
                    checkForTable(
                      dataObj.description.trim().replace(/[\r\n]+/g, "")
                    ) ||
                    checkForTableBlog(
                      dataObj.description.trim().replace(/[\r\n]+/g, "")
                    ),
                }}
              />
            </div>
            {/* Leave empty space one side */}
            <div></div>
          </div>
        ) : ((dataObj &&
            dataObj.contentUrl &&
            dataObj.contentUrl.indexOf(".pdf") > -1) ||
            (dataObj &&
              dataObj.contentUrl &&
              dataObj.contentUrl.indexOf(".ppt") > -1)) &&
          isMobile ? (
          // PDF and PPT Modal
          <iframe
            width="100%"
            height="100%"
            src={
              "https://drive.google.com/viewerng/viewer?embedded=true&url=" +
              dataObj.contentUrl
            }
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        ) : (
          // Video Modal
          <iframe
            width="100%"
            height="100%"
            src={
              dataObj &&
              dataObj.contentUrl &&
              (dataObj.contentUrl.indexOf("youtube") > -1 ||
                dataObj.contentUrl.indexOf("easetolearn") > -1 ||
                dataObj.contentUrl.indexOf("wikipedia") > -1)
                ? dataObj.contentUrl + "?autoplay=1"
                : dataObj.contentUrl
            }
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        )}
      </Dialog>
    </>
  ) : (
    <>
      <Dialog
        fullScreen
        style={{ margin: 15 }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <iframe
          width="100%"
          height="100%"
          src="https://www.google.com/search?igu=1"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </Dialog>
    </>
  );
});

export default CustomizedDialogs;
